import { GET_MFH_ORDER_BOOK, } from "../../interface/orderBook";
const initState = {
    data: {
        ordLst: [],
        isModified: true,
        isCancel: false,
    },
};
const MFOrderBookHoldingsReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_MFH_ORDER_BOOK:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        default:
            return Object.assign({}, state);
    }
};
export default MFOrderBookHoldingsReducer;
